module.exports = __webpack_public_path__ + "static/media/logo.9ac4cb6b.png";